import React from 'react';
import { useDocumentTypeQuery } from '../../generated/graphql';
import { DocumentTypeList, DocumentTypeListProps } from './components/DocumentTypeList';
import { DocumentTypeViewer } from './components/DocumentTypeViewer';
import { PathNavigator } from './components/PathNavitagor';

interface DocumentTypeSelectorProps {
    documentTypeId: string | number;
    onClick: DocumentTypeListProps['onClick'];
    navigateToCreateDocumentType?: DocumentTypeListProps['navigateToCreateDocumentType'];
}

export const DocumentTypeSelector: React.FC<DocumentTypeSelectorProps> = ({ documentTypeId, ...rest }) => {
    const { data, loading } = useDocumentTypeQuery({
        variables: { id: +documentTypeId },
    });

    if (loading) {
        return <div>Loading</div>;
    }

    if (!data?.documentType) {
        return <div>Error</div>;
    }

    const documentType = data.documentType;
    console.log(documentType);

    const categories = documentType.children.filter((el) => el.isCategory);
    const documents = documentType.children.filter((el) => !el.isCategory);
    return (
        <div>
            <PathNavigator path={documentType.path} onClick={rest.onClick} />
            {documentType.isCategory ? (
                <>
                    {!!categories.length && <DocumentTypeList isCategory={true} array={categories} {...rest} />}
                    {!!documents.length && <DocumentTypeList isCategory={false} array={documents} {...rest} />}
                </>
            ) : (
                <DocumentTypeViewer documentType={documentType} />
            )}
        </div>
    );
};
